import { takeLatest } from 'redux-saga';
import { put, call, fork } from 'redux-saga/effects';
import getUserData from './utils';
import { GET_USER, GET_USER_SUCCESS, GET_USER_ERROR } from './constants';

export function* getUser() {
  try {
    const user = yield call(getUserData);
    yield put({ type: GET_USER_SUCCESS, user });
  } catch (error) {
    yield put({ type: GET_USER_ERROR, error: error.message });
  }
}

export function* watchGetUser() {
  yield takeLatest(GET_USER, getUser);
}

export default function* userHandlerSagas() {
  yield [fork(watchGetUser)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/sagas.js
 **/